import { formatShortDate } from '../list/expense-labels';
import type { ReportPurposeFields } from './types';

/** «M01 · Fiera»: the purpose's code and label; null on an R2 note, which has no purpose. */
export function purposeText(report: ReportPurposeFields): string | null {
  return report.purpose ? `${report.purpose.code} · ${report.purpose.label}` : null;
}

/** «12/10/26 – 14/10/26» of a Trasferta; null when the report has no trip. */
export function tripDates(report: ReportPurposeFields): string | null {
  if (!report.tripStart || !report.tripEnd) return null;
  return `${formatShortDate(report.tripStart)} – ${formatShortDate(report.tripEnd)}`;
}
